module.exports = __webpack_public_path__ + "img/market-trends.4b54d9f7.jpg";